function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.507 24a.505.505 0 01-.354-.146.497.497 0 01-.121-.511l2.121-6.364a.396.396 0 01.021-.047.47.47 0 01.087-.133l.009-.01L18.033 1.025a3.483 3.483 0 012.433-.989l.065.001a3.5 3.5 0 012.457 5.931l-.698.698-.015.016-15.05 15.05a.304.304 0 01-.033.028.529.529 0 01-.112.071l-.005.002a.24.24 0 01-.054.023L.665 23.974A.49.49 0 01.507 24zm.791-1.291l4.648-1.549-3.099-3.099zm5.574-2.037L21.215 6.329l-3.536-3.536L3.336 17.136zM21.921 5.621l.354-.354a2.5 2.5 0 00-1.761-4.23h-.045a2.488 2.488 0 00-1.736.702l-.347.347z"
});

function SvgEdit(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "edit.5accf.svg";
export { SvgEdit as ReactComponent };